import type { AdminState } from '../../../redux/redux.types';
import type { UsersState } from './Users.types';
import { generateUseSubstateSelector } from '@orthly/redux-async-actions';
import type { TypedUseSelectorHook } from 'react-redux';

export const useUsersSelector: TypedUseSelectorHook<UsersState> = generateUseSubstateSelector<AdminState, 'users'>(
    'users',
);
